import type { SummaryRowProps } from "./summary-row.type";
import styles from "./summary-row.module.css";

export const SummaryRow = ({
  label,
  value,
  highlight,
  separator,
}: SummaryRowProps) => (
  <div className={`${styles.row} ${separator ? styles["row-separator"] : ""}`}>
    <span className={styles.label}>{label}</span>
    <span className={`${styles.value} ${highlight ? styles["value-highlight"] : ""}`}>
      {value}
    </span>
  </div>
);
